var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 4.5C0.00390625 3.70435 0.319977 2.94129 0.882586 2.37868C1.4452 1.81607 2.20826 1.5 3.00391 1.5H21.0039C21.7996 1.5 22.5626 1.81607 23.1252 2.37868C23.6878 2.94129 24.0039 3.70435 24.0039 4.5V19.5C24.0039 20.2956 23.6878 21.0587 23.1252 21.6213C22.5626 22.1839 21.7996 22.5 21.0039 22.5H3.00391C2.20826 22.5 1.4452 22.1839 0.882586 21.6213C0.319977 21.0587 0.00390625 20.2956 0.00390625 19.5V4.5ZM1.50391 18V19.5C1.50391 19.8978 1.66194 20.2794 1.94325 20.5607C2.22455 20.842 2.60608 21 3.00391 21H21.0039C21.4017 21 21.7833 20.842 22.0646 20.5607C22.3459 20.2794 22.5039 19.8978 22.5039 19.5V14.25L16.8384 11.3295C16.6977 11.259 16.5385 11.2346 16.3832 11.2596C16.2278 11.2847 16.0843 11.3579 15.9729 11.469L10.4079 17.034L6.41791 14.376C6.27385 14.2801 6.10105 14.237 5.92881 14.2539C5.75658 14.2709 5.59551 14.3468 5.47291 14.469L1.50391 18ZM9.00391 8.25C9.00391 7.65326 8.76685 7.08097 8.3449 6.65901C7.92294 6.23705 7.35064 6 6.75391 6C6.15717 6 5.58487 6.23705 5.16292 6.65901C4.74096 7.08097 4.50391 7.65326 4.50391 8.25C4.50391 8.84674 4.74096 9.41903 5.16292 9.84099C5.58487 10.2629 6.15717 10.5 6.75391 10.5C7.35064 10.5 7.92294 10.2629 8.3449 9.84099C8.76685 9.41903 9.00391 8.84674 9.00391 8.25Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/upload_img.626944f9adbd50b728ecab1e9366cd07.svg";
export { ForwardRef as ReactComponent };